import { render } from "./BaseButton.vue?vue&type=template&id=1973b1ee&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=1973b1ee&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1973b1ee"

export default script